// Manages: users/{uid}, households/{householdId}, invites/{code}
import { getUserProfile, createHousehold, joinHousehold, getHouseholdInfo, leaveHousehold } from '@/lib/firebase';

export const householdService = {
  getUserProfile,
  createHousehold,
  joinHousehold,
  getHouseholdInfo,
  leaveHousehold,
};
